import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import UILink from '@src/components/UILink';
import UICounter from '@src/components/UICounter';
import PopoverShare from '@src/components/PopoverShare';
import MediaBigManage from '@src/components/MediaBigManage';
import {
	IconDownload,
	IconLike,
	IconLikeFull,
	IconShare,
} from '@src/components/Icon';
import HeaderShowContact from '@src/components/HeaderShowContact';

import useStyles from 'isomorphic-style-loader/useStyles';
import css from './style.module.sass';

const MediaBigFS = (props) => {
	useStyles(css);
	const {
		label,
		HeaderRP,
		MediaRP,
		color,
		onChangeColor,
		likes,
		usersChoice,
		popoverProps,
		hrefDownload,
		mediaProps,
		headerProps,
		Popover,
	} = props;

	const popoverParentRef = React.useRef();

	return (
		<div
			className={css.wrap}
			ref={popoverParentRef}
			data-color={color || 'unset'}
		>
			{HeaderRP && (
				<div className={css.header}>
					<HeaderRP {...headerProps}>
						{label && (
							<div className={css.headerLabel}>{label}</div>
						)}
					</HeaderRP>
				</div>
			)}

			{MediaRP && (
				<div className={css.media}>
					<MediaRP {...mediaProps} />
				</div>
			)}

			<div className={css.footer}>
				{onChangeColor && (
					<div className={cn(css.item, css.switch)}>
						<div
							className={css.switchItem}
							tabIndex={0}
							role="button"
							onClick={onChangeColor}
							data-color="a"
						/>
						<div
							className={css.switchItem}
							tabIndex={0}
							role="button"
							onClick={onChangeColor}
							data-color="b"
						/>
						<div
							className={css.switchItem}
							tabIndex={0}
							role="button"
							onClick={onChangeColor}
							data-color="c"
						/>
						<div
							className={css.switchItem}
							tabIndex={0}
							role="button"
							onClick={onChangeColor}
							data-color="d"
						/>
						<div
							className={css.switchItem}
							tabIndex={0}
							role="button"
							onClick={onChangeColor}
							data-color="e"
						/>
						<div
							className={css.switchItem}
							tabIndex={0}
							role="button"
							onClick={onChangeColor}
							data-color="f"
						/>
					</div>
				)}

				{likes && (
					<div className={cn(css.item, css.button)}>
						<UICounter
							icon={<IconLike />}
							iconActive={<IconLikeFull />}
							color="white"
							{...likes}
						>
							{usersChoice}
						</UICounter>
					</div>
				)}

				{popoverProps && (
					<div className={cn(css.item, css.button)}>
						<Popover
							parentRef={popoverParentRef}
							{...popoverProps}
							align="center"
						>
							<IconShare className={css.icon} />
						</Popover>
					</div>
				)}

				{hrefDownload && (
					<a
						className={cn(css.item, css.button)}
						href={hrefDownload}
						download
					>
						<IconDownload className={css.icon} />
					</a>
				)}
			</div>
		</div>
	);
};

MediaBigFS.propTypes = {
	label: PropTypes.string,
	HeaderRP: PropTypes.elementType,
	MediaRP: PropTypes.elementType,
	color: PropTypes.oneOf([undefined, 'a', 'b', 'c', 'd', 'e', 'f']),
	onChangeColor: PropTypes.func,
	likes: PropTypes.shape(UILink.type.propTypes),
	usersChoice: PropTypes.oneOfType([
		PropTypes.arrayOf(PropTypes.node),
		PropTypes.node,
	]),
	popoverProps: PropTypes.shape(PopoverShare.type.propTypes),
	hrefDownload: PropTypes.string,
	mediaProps: PropTypes.shape(MediaBigManage.type.propTypes),
	headerProps: PropTypes.shape(HeaderShowContact.type.propTypes),
	Popover: PropTypes.elementType,
};

MediaBigFS.defaultProps = {
	label: undefined,
	HeaderRP: undefined,
	MediaRP: undefined,
	color: undefined,
	onChangeColor: undefined,
	likes: undefined,
	usersChoice: undefined,
	popoverProps: undefined,
	hrefDownload: undefined,
	mediaProps: undefined,
	headerProps: undefined,
	Popover: PopoverShare,
};

export default MediaBigFS;
